var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65629 8.8846L12.3424 6.52278M12.2269 13.7493L7.58351 11.2493M17.0846 5.41602C17.0846 6.79672 15.9654 7.91602 14.5846 7.91602C13.2039 7.91602 12.0846 6.79672 12.0846 5.41602C12.0846 4.03531 13.2039 2.91602 14.5846 2.91602C15.9654 2.91602 17.0846 4.03531 17.0846 5.41602ZM7.91797 9.99935C7.91797 11.3801 6.79868 12.4993 5.41797 12.4993C4.03726 12.4993 2.91797 11.3801 2.91797 9.99935C2.91797 8.6186 4.03726 7.49935 5.41797 7.49935C6.79868 7.49935 7.91797 8.6186 7.91797 9.99935ZM17.0846 14.5827C17.0846 15.9634 15.9654 17.0827 14.5846 17.0827C13.2039 17.0827 12.0846 15.9634 12.0846 14.5827C12.0846 13.2019 13.2039 12.0827 14.5846 12.0827C15.9654 12.0827 17.0846 13.2019 17.0846 14.5827Z",
    stroke: "#262429",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepost);
export default __webpack_public_path__ + "static/media/repost.d18cf0ee9ac6a918507d175f896f76f6.svg";
export { ForwardRef as ReactComponent };